import styled, {css} from "styled-components";
import Colors from 'constants/Colors';
import { FiraSansBold } from 'components/Text';
import { Breakpoints } from "constants/Breakpoints";


export const ButtonContent = styled.div`
  display:flex;
  flex-direction:row;
  justify-content: space-evenly;
  background-color:#FFF;  
  
  @media (max-width: ${Breakpoints.lg}) {  
      flex-wrap: wrap;
      padding-right: 10px;
      width: 100%;
  }
`;

export const Title = styled.label`
  font-size: 13px;
  color: ${Colors.GRAY[6]};
  ${FiraSansBold}
`;

export const BorderSwitch = styled.div`  
  background: ${Colors.GRAY[6]};
  padding-left: 1px;
  border-radius: 14px;
  width: 57px;
  padding-top: 1px;
  height: 30px;
  display: -webkit-inline-box;

  ${({ newBorder }) =>
    newBorder
    ? css`
        margin-top: 10px;
        `
    : ""}
`;
